import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_LIFF_ID: z.string(),
    VITE_LINE_OA_BASIC_ID: z.string(),
    VITE_API_URL: z.string(),
    VITE_ALLOW_EXTERNAL: z.stringbool().default(false),
    VITE_FIREBASE_API_KEY: z.string().optional(),
    VITE_FIREBASE_AUTH_DOMAIN: z.string().optional(),
    VITE_FIREBASE_PROJECT_ID: z.string().optional(),
    VITE_FIREBASE_STORAGE_BUCKET: z.string().optional(),
    VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().optional(),
    VITE_FIREBASE_APP_ID: z.string().optional(),
    VITE_FIREBASE_DATABASE_URL: z.string().optional(),
    VITE_FIRESTORE_PREFIX: z.string().default(''),
    VITE_FIRESTORE_SUFFIX: z.string().default(''),
    VITE_SENTRY_DSN: z.string().optional(),
    VITE_MODE: z
      .enum(['development', 'production', 'staging'])
      .default('development'),
    VITE_FIREBASE_EMULATORS: z.stringbool().default(false),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
})
